import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Capacitor } from "@capacitor/core";
import logo from "@/assets/logo.png";
import { APP_VERSION } from "@/version";

const Landing = () => {
  const navigate = useNavigate();
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  // Already signed in? Hand off to the protected area, which owns the backend
  // session handshake. Landing no longer exchanges tokens itself, so the two
  // pages can't ping-pong on a transient backend error anymore.
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate, isAuthenticated, isLoading]);

  const handleLogin = async () => {
    if (Capacitor.isNativePlatform()) {
      await loginWithRedirect({
        async openUrl(url) {
          window.open(url, '_system');
        }
      });
    } else {
      loginWithRedirect();
    }
  };

  return (
    <div className="landing-container">
      <div className="landing-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src={logo} alt="Cilantro Alert" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
          Cilantro Alert
        </h2>
        <button 
          onClick={() => navigate('/about')}
          style={{ 
            background: 'transparent', 
            border: 'none', 
            color: 'hsl(var(--muted-foreground))', 
            cursor: 'pointer',
            fontSize: '0.9rem',
            textDecoration: 'underline'
          }}
          data-testid="about-link"
        >
          About
        </button>
      </div>
      <div className="landing-hero">
        <h1 className="hero-title" data-testid="landing-title">Never Get Poisoned Again</h1>
        <p className="hero-subtitle" data-testid="landing-subtitle">
          Scan barcodes to instantly check if products contain cilantro. 
          Join our community to help others avoid this controversial herb.
        </p>
        <button 
          className="cta-button" 
          onClick={handleLogin}
          disabled={isLoading}
          data-testid="login-button"
        >
          Get Started — It's Free
        </button>
        <p style={{ fontSize: '0.7rem', color: 'hsl(var(--muted-foreground))', marginTop: '8px' }}>{APP_VERSION}</p>
      </div>
    </div>
  );
};

export default Landing;